import type { ReactElement } from 'react';
import { MainPageLayout } from '../components/layouts/MainPageLayout/MainPageLayout';

const OverviewPage = () => {
  return null;
};

OverviewPage.title = 'Portfolio performance overview';

OverviewPage.getLayout = (_page: ReactElement) => {
  return <MainPageLayout />;
};

export default OverviewPage;
